import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { querySmsNoticeList, updateSmsNotice } from '@/api/sms';
const __sfc_main = {};
__sfc_main.props = {
  // 业务类型 1:订车工单,2:商户审核
  type: {
    type: Number,
    default: 1
  },
  // 当有新的{{ title }}时，下列手机号将收到短信推送
  title: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    proxy
  } = getCurrentInstance();
  const emit = __ctx.emit;
  const props = __props;

  // 是否设置了短信提醒
  const effectMobiles = ref([]); // 有效的手机号List
  const smsText = computed(() => {
    const len = effectMobiles.value.length;
    return len > 0 ? '有' : '无';
  });

  // 弹窗
  const visible = ref(false);
  function doSms() {
    getList();
    visible.value = true;
  }

  // 获取列表
  const formData = ref({
    list: []
  });
  const defaultItem = {
    mobiles: '',
    type: props.type
  };
  function getList() {
    querySmsNoticeList({
      type: props.type
    }).then(res => {
      formData.value.list = res.mobiles.map(ele => {
        return {
          mobiles: ele
        };
      });
      effectMobiles.value = [...res.mobiles];
      if (!formData.value.list.length) {
        doAdd();
      }
    });
  }
  onMounted(() => {
    getList();
  });

  // 添加手机号
  function doAdd() {
    formData.value.list.push({
      ...defaultItem
    });
  }

  // 删除手机号
  function doDel(index) {
    formData.value.list.splice(index, 1);
  }

  // 全部清空
  function doDelAll() {
    formData.value.list.forEach(ele => {
      ele.mobiles = '';
    });
  }

  // 提交
  const confirmLoading = ref(false);
  function doConfirm() {
    proxy.$refs.queryRef.validate(valid => {
      if (!valid) {
        return;
      }
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
      const mobiles = formData.value.list.filter(ele => reg.test(ele.mobiles)).map(ele => ele.mobiles);
      console.log('----:', mobiles);
      confirmLoading.value = true;
      updateSmsNotice({
        mobiles,
        type: props.type
      }).then(() => {
        effectMobiles.value = mobiles;
        proxy.$message.success('操作成功');
        visible.value = false;
        emit('change');
      }).finally(() => {
        confirmLoading.value = false;
      });
    });
  }
  return {
    smsText,
    visible,
    doSms,
    formData,
    doAdd,
    doDel,
    doDelAll,
    confirmLoading,
    doConfirm
  };
};
export default __sfc_main;